import { CondominiumMultiSelector } from "./Condominium/ComdominiumMultiSelector";
import { CaptadorMultiSelector } from "./Captador/CaptadorMultiSelector";
import { MultiSelect } from "./multiSelect";
import { RegionMultiSelector } from "./region/RegionSelector";

// PropertyFilters.tsx

type Option = { value: string; label: string };

interface PropertyFiltersProps {
  // Estados dos filtros
  propertyType: string[];
  setPropertyType: (value: string[]) => void;
  region: string[];
  setRegion: (value: string[]) => void;
  status: string[];
  setStatus: (value: string[]) => void;
  type: string[];
  setType: (value: string[]) => void;
  lado: string[];
  setLado: (value: string[]) => void;
  condominium: string[];
  setCondominium: (value: string[]) => void;
  usableAreaMin: string;
  setUsableAreaMin: (value: string) => void;
  usableAreaMax: string;
  setUsableAreaMax: (value: string) => void;
  bedrooms: string[];
  setBedrooms: (value: string[]) => void;
  captador: string[];
  setCaptador: (value: string[]) => void;
  praia: string;
  setPraia: (value: string) => void;
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  priceRange: string;
  setPriceRange: (value: string) => void;

  // Funções
  handleSearch: () => void;
  clearFilters: () => void;

  // Opções prontas (vêm do pai) - Região e Condomínio não são mais necessárias
  statusOptions: Option[];
  propertyTypeOptions: Option[];
  subtypeOptions: Option[];
  priceRangeOptions: Option[];

  // Pode manter se precisar para controles de UI/visibilidade
  isAdmin: boolean;
}

export function PropertyFilters({
  propertyType,
  setPropertyType,
  region,
  setRegion,
  status,
  setStatus,
  type,
  setType,
  lado,
  setLado,
  condominium,
  setCondominium,
  usableAreaMin,
  setUsableAreaMin,
  usableAreaMax,
  setUsableAreaMax,
  bedrooms,
  setBedrooms,
  captador,
  setCaptador,
  praia,
  setPraia,
  searchQuery,
  setSearchQuery,
  priceRange,
  setPriceRange,
  handleSearch,
  clearFilters,
  statusOptions,
  propertyTypeOptions,
  subtypeOptions,
  priceRangeOptions,
}: PropertyFiltersProps) {
  // Opções locais simples
  const ladoOptions: Option[] = [
    { value: "P", label: "P" },
    { value: "M", label: "M" },
    { value: "O", label: "O" },
  ];

  const bedroomsOptions: Option[] = [
    { value: "1", label: "1 dormitório" },
    { value: "2", label: "2 dormitórios" },
    { value: "3", label: "3 dormitórios" },
    { value: "4", label: "4+ dormitórios" },
  ];
  const handleMinAreaChange = (value: string) => {
    // Remove caracteres não numéricos e permite apenas números e ponto decimal
    const numericValue = value.replace(/[^0-9.]/g, "");
    setUsableAreaMin(numericValue);
  };

  const handleMaxAreaChange = (value: string) => {
    const numericValue = value.replace(/[^0-9.]/g, "");
    setUsableAreaMax(numericValue);
  };
  return (
    <div className="border-b border-gray-200 bg-white p-4 shadow-sm sm:p-6">
      <div className="space-y-4 sm:space-y-6">
        {/* Primeira linha de filtros */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          <div className="space-y-2">
            <RegionMultiSelector value={region} onChange={setRegion} />
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Status"
              placeholder="Status do imóvel"
              options={statusOptions}
              value={status}
              onChange={setStatus}
            />
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Tipo"
              placeholder="Tipo de imóvel"
              options={propertyTypeOptions}
              value={propertyType}
              onChange={setPropertyType}
            />
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Subtipo"
              placeholder="Subtipo"
              options={subtypeOptions}
              value={type}
              onChange={setType}
            />
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Faixa de Preço"
              placeholder="Selecione o preço"
              options={priceRangeOptions}
              value={priceRange ? [priceRange] : []}
              onChange={(value) => setPriceRange(value[0] || "")}
            />
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Lado"
              placeholder="Selecione o lado"
              options={ladoOptions}
              value={lado}
              onChange={setLado}
            />
          </div>
        </div>

        {/* Segunda linha de filtros */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          <div className="space-y-2">
            <CondominiumMultiSelector
              value={condominium}
              onChange={setCondominium}
            />
          </div>
          <div className="space-y-2">
            <CaptadorMultiSelector
              value={captador}
              onChange={setCaptador}
            />
          </div>
          <div className="space-y-2">
            <label className="text-base font-semibold text-gray-800">
              Praia
            </label>
            <input
              type="text"
              placeholder="Nome da praia"
              value={praia}
              onChange={(e) => setPraia(e.target.value)}
              className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
            />
          </div>
          <div className="space-y-2">
            <label className="text-base font-semibold text-gray-800">
              Área Útil (m²)
            </label>
            <div className="flex space-x-2">
              <input
                type="text"
                placeholder="Mín"
                value={usableAreaMin}
                onChange={(e) => handleMinAreaChange(e.target.value)}
                className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
              <input
                type="text"
                placeholder="Max"
                value={usableAreaMax}
                onChange={(e) => handleMaxAreaChange(e.target.value)}
                className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
            </div>
          </div>
          <div className="space-y-2">
            <MultiSelect
              label="Dormitórios"
              placeholder="Número de dormitórios"
              options={bedroomsOptions}
              value={bedrooms}
              onChange={setBedrooms}
            />
          </div>
        </div>

        {/* Barra de busca e botões */}
        <div className="flex flex-col space-y-4 sm:flex-row sm:items-end sm:space-x-4 sm:space-y-0">
          <div className="flex-1 space-y-2">
            <label className="text-base font-semibold text-gray-800">
              Buscar Imóveis
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="Digite endereço, bairro, código ou tag..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-lg border border-gray-300 bg-white py-3 pl-12 pr-4 text-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />
              <i className="fas fa-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
            </div>
          </div>

          <div className="flex flex-col space-y-2 sm:flex-row sm:space-x-3 sm:space-y-0">
            <button
              onClick={handleSearch}
              className="flex items-center justify-center space-x-2 rounded-lg bg-blue-600 px-6 py-3 text-sm font-medium text-white hover:bg-blue-700"
            >
              <i className="fas fa-search"></i>
              <span>Buscar</span>
            </button>

            <button
              onClick={clearFilters}
              className="flex items-center justify-center space-x-2 rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              <i className="fas fa-times"></i>
              <span>Limpar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
